import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useLocation } from 'react-router';
import { TextVariant } from '@naf/text';
import { Button } from '@naf-simba/elements-buttons';
import Box from '@mui/material/Box';
import { LoginButton } from '../../../components/my-naf/Login/Login';
import { useTrackPromotion } from '../../../hooks/useTrackPromotion';
import { CtaButtonWithDiscountInfoProps } from './BenefitCallToActions.types';
import * as S from './BenefitCallToActions.styles';

const CtaButtonWithDiscountInfo = ({ onClickBecomeAMember }: CtaButtonWithDiscountInfoProps) => {
  const { isAuthenticated } = useAuth0();
  const location = useLocation();
  const ctaText = 'Bli medlem';

  const { wrapperRef, trackSelectPromotion } = useTrackPromotion({
    creative_slot: 'medlemsfordel',
    creative_name: `CTA | outlined-signature | ${ctaText}`,
  });

  const becomeMemberPath = '/bli-medlem';

  return (
    <>
      <S.DiscountInfoText tag="p" variant={TextVariant.ArticleText}>
        {isAuthenticated
          ? 'Du må være medlem for å få tilgang til rabatt'
          : 'Logg inn for å kunne ta i bruk din medlemsfordel.'}
      </S.DiscountInfoText>
      <Box sx={(theme) => ({ display: 'flex', gap: theme.spacing('ml') })}>
        {!isAuthenticated ? <LoginButton buttonText="Logg inn" returnUrl={location.pathname} /> : null}
        <div ref={wrapperRef}>
          <Button
            onClick={(event) => {
              trackSelectPromotion();
              onClickBecomeAMember(event);
            }}
            to={becomeMemberPath}
            color="primary"
            variant="outlined"
          >
            {ctaText}
          </Button>
        </div>
      </Box>
    </>
  );
};

export default CtaButtonWithDiscountInfo;
